var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 38,
    viewBox: "0 0 20 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6780_135448",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 38
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "matrix(-0.83205 0.5547 0 1 20 0)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6780_135448)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.7639 11.8509L13.0105 10.3532C13.2227 10.2117 13.4005 10.0067 13.544 9.73797C13.6876 9.46945 13.7593 9.20844 13.7593 8.95494C13.7593 8.70144 13.6876 8.53674 13.5442 8.46083C13.4008 8.38492 13.2231 8.41765 13.0111 8.559L7.02575 12.5492C6.81371 12.6906 6.63489 12.8956 6.48928 13.1641C6.34367 13.4327 6.27087 13.6937 6.27087 13.9472C6.27087 14.2007 6.34263 14.3661 6.48616 14.4432C6.62969 14.5205 6.80754 14.4885 7.01971 14.347L9.26625 12.8493V14.6536C9.26625 14.9091 9.33802 15.0755 9.48154 15.1528C9.62507 15.2299 9.80292 15.1978 10.0151 15.0563C10.2273 14.9149 10.4051 14.7099 10.5486 14.4414C10.6922 14.1727 10.7639 13.9106 10.7639 13.6551V11.8509ZM16.0059 22.1878V16.7448C16.0059 16.4899 15.9345 16.3226 15.7918 16.2427C15.6491 16.1628 15.4723 16.1932 15.2614 16.3338C15.0505 16.4744 14.8731 16.6792 14.7293 16.948C14.5853 17.217 14.5134 17.4793 14.5134 17.735V17.7575L12.2616 19.2587V16.5587L12.2804 16.5462C12.4931 16.4044 12.6714 16.1992 12.8154 15.9307C12.9593 15.6623 13.0313 15.4006 13.0313 15.1456C13.0313 14.8906 12.9595 14.7246 12.816 14.6478C12.6726 14.5709 12.4948 14.6032 12.2826 14.7446L7.75379 17.7639C7.54176 17.9052 7.36293 18.1102 7.21733 18.3788C7.07172 18.6473 6.99891 18.9084 6.99891 19.1619C6.99891 19.4154 7.07089 19.5806 7.21483 19.6574C7.35877 19.7345 7.53711 19.7021 7.74984 19.5603L7.76856 19.5478V22.254L5.52202 23.7517V23.7292C5.52202 23.4736 5.45026 23.3071 5.30673 23.2298C5.1632 23.1524 4.98535 23.1845 4.77318 23.326C4.56101 23.4674 4.38315 23.6722 4.23962 23.9404C4.0961 24.2084 4.02433 24.4699 4.02433 24.7249V30.1679C4.02433 30.4228 4.09568 30.5901 4.23838 30.67C4.38107 30.7499 4.55788 30.7195 4.76881 30.5789C4.97973 30.4383 5.15703 30.2338 5.3007 29.9655C5.44423 29.6973 5.51599 29.4357 5.51599 29.1807V29.1557L14.5082 23.161V23.186C14.5082 23.441 14.5795 23.6071 14.7222 23.6845C14.8649 23.7619 15.0417 23.7303 15.2526 23.5896C15.4636 23.449 15.6418 23.2439 15.7874 22.9744C15.9331 22.705 16.0059 22.4428 16.0059 22.1878ZM14.5082 21.361L5.52202 27.3517V25.5517L9.26625 23.0556V18.5556L10.7639 17.5571V22.0571L14.5082 19.561V21.361Z",
    fill: "#FF0F64"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGas);
export default __webpack_public_path__ + "static/media/gas.dda43eb8cce951e5228d104cb9dcbb43.svg";
export { ForwardRef as ReactComponent };